import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { InfoBanner } from '@beef/smart-kit';
import { Link } from '@beef/ui-kit';
import { compose } from '@beef/utils';
import { getHomeTariffBannerContentData } from "../../store/blocks/banner/selectors";
import { isUserFttb } from "../../store/shared/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
var _HomeTariffsBannerBlock = function _HomeTariffsBannerBlock(_ref) {
  var bannerData = _ref.bannerData,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "blocks-HomeTariffsBannerBlock"
  }, /*#__PURE__*/React.createElement(InfoBanner, bannerData, /*#__PURE__*/React.createElement(Link, {
    buttonSize: "l",
    buttonVariant: "main",
    href: bannerData.link,
    target: bannerData.linkTarget,
    variant: "button",
    "data-t-id": "blocks-HomeTariffsBannerBlock"
  }, bannerData.buttonText)));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    bannerData: getHomeTariffBannerContentData(state),
    shouldRender: isUserFttb(state)
  };
};
var connector = connect(mapStateToProps);
export var HomeTariffsBannerBlock = compose(defineBlock(FttbBlocks.HOME_TARIFFS_BANNER), connector, withRenderFlag)(_HomeTariffsBannerBlock);